import { createRetailApiClient } from "./RetailApiClient";

export type { RetailApiClient } from "./RetailApiClient";

export const retailApiClient = createRetailApiClient();
export const { platform: platformApi, configurator: configuratorApi, cms: cmsApi } = retailApiClient;
